import React, { useEffect } from "react";
import PropTypes from "prop-types"; // Import PropTypes
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { HomeJournalDatagetById } from "../../Redux/home/homeslice";

const Bannerpage = (props) => {
    const { homeJournalDataById } = useSelector((state) => state.Home);
    console.log("homeJournalDataById in Banner:", homeJournalDataById);
    console.log("homeJournalDataById.data:", homeJournalDataById?.data);
    console.log("First item in data:", homeJournalDataById?.data?.[0]);
    const dispatch = useDispatch();
    const navigate = useNavigate();

    useEffect(() => {
        dispatch(HomeJournalDatagetById(props?.name));
    }, []);

    const handleSubmitClick = () => {
        console.log("Click - passing data:", homeJournalDataById?.data?.[0] || null);
        navigate(
            props?.name ? `/${props?.name}/manuscript-form` : "/online-submission",
            { state: { data: homeJournalDataById?.data?.[0] } }
        );
    };

    return (
        <>
            <div className="inner-banner">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-8">
                            <h2 style={{ marginBottom: "8px" }}>{homeJournalDataById?.data?.[0]?.journal_name}</h2>
                            {/* <p
                                dangerouslySetInnerHTML={{
                                    __html: homeJournalDataById?.data?.[0]?.journal_homes?.[0]?.about_journal,
                                }}
                                className="truncate-two-lines"
                                style={{ marginBottom: "8px" }}
                            ></p> */}

                            <div
                                className="course-info d-flex align-items-end border-bottom-0 m-0 p-0"
                                style={{ justifyContent: "end", margin: "4px 0px" }}
                            >
                                <div className="cou-info">
                                    <h4 style={{ textAlign: "end", marginBottom: "4px" }}>
                                        {homeJournalDataById?.data?.[0]?.is_open_access ? "Open Access" : "Subscription"}

                                    </h4>
                                </div>
                            </div>
                            <div
                                className="course-info d-flex align-items-end border-bottom-0 m-0 p-0"
                                style={{ justifyContent: "start", margin: "4px 0px" }}
                            >
                                <div className="cou-info">
                                    <div className="all-btn all-category">
                                        <button
                                            onClick={handleSubmitClick}
                                            className="btn btn-primary"
                                        >
                                            Submit Manuscript
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                   {/* this is for testing in bitbucket */}

                        <div className="col-lg-3">
                            {homeJournalDataById?.data?.length > 0 && homeJournalDataById?.data[0]?.issn ? (
                                <p style={{ marginBottom: "4px" }}>ISSN: {homeJournalDataById.data[0].issn}</p>
                            ) : null}
                            {homeJournalDataById?.data?.length > 0 && homeJournalDataById?.data[0]?.whatsapp_number ? (
                                <span className="web-badge mb-3">
                                    <i className="fa-brands fa-whatsapp"></i> {homeJournalDataById.data[0].whatsapp_number}
                                </span>
                            ) : null}
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

// Add propTypes validation
Bannerpage.propTypes = {
    name: PropTypes.string, // Validate `name` as a string
};

export default Bannerpage;
